export const NAV_TYPE_TABS = 'tabs';
export const NAV_TYPE_PILLS = 'pills';
export const NAV_TYPE_VERTICAL = 'vertical';

export const NAV_TYPES = [
  NAV_TYPE_TABS,
  NAV_TYPE_PILLS,
  NAV_TYPE_VERTICAL,
];
